<template>
  <!--  数据词典-->
  <div class="main-box">
    <!--  标题-->
    <div class="title-css">{{$t('dataDictionary')}}</div>
    <div class="main-box-all-css">
      <!-- 主要内容部分 -->
      <div class="main-box-css">
        <!-- 左边表单部分 -->
        <div class="left-box">
          <!--          第一行  button 部分-->
          <div class="line-button-box">
            <el-button class="button-css" @click="handleAddClick1">{{$t('new')}}</el-button>
          </div>
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            height="560px"
            @selection-change="handleSelectionChange1"
            @cell-click="tableCellClick"
            :cell-class-name="({ row, column, rowIndex, columnIndex }) => (
            (row.index = rowIndex), (column.index = columnIndex))"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column prop="id" label="ID" width="100" :show-overflow-tooltip="true">
              <template slot="header" slot-scope="scope">
                <p>{{$t('id')}}</p>
                <el-input
                  v-model="searchData1"
                  size="mini"
                  placeholder="Search"
                  @input="dataDictionaryFuzzyQuery"
                  clearable
                />
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.id }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="uniquelyIdentifies" label="唯一标识" width="150" :show-overflow-tooltip="true">
              <template slot="header" slot-scope="scope">
                <p>{{$t('uniquelyIdentifies')}}</p>
                <el-input
                  v-model="searchData2"
                  size="mini"
                  placeholder="Search"
                  @input="dataDictionaryFuzzyQuery"
                  clearable
                />
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.code }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" width="100" :show-overflow-tooltip="true">
              <template slot="header" slot-scope="scope">
                <p>{{$t('dataName')}}</p>
                <el-input
                  v-model="searchData3"
                  size="mini"
                  placeholder="Search"
                  @input="dataDictionaryFuzzyQuery"
                  clearable
                />
              </template>
              <template slot-scope="scope">
                <span
                  v-if="scope.row.index === tableCellClickRowIndex && scope.column.index === tableCellClickColumnIndex">
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.name"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
                </span>
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="createId" label="创建人id" width="150" :show-overflow-tooltip="true">
              <template slot="header" slot-scope="scope">
                <p>{{$t('creatorname')}}</p>
                <el-input
                  v-model="searchData4"
                  size="mini"
                  placeholder="Search"
                  @input="dataDictionaryFuzzyQuery"
                  clearable
                />
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.createId }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="createName" label="创建人名称" width="150">
              <template slot="header" slot-scope="scope">
                <p>{{$t('creatorName')}}</p>
                <el-input
                  v-model="searchData5"
                  size="mini"
                  placeholder="Search"
                  @input="dataDictionaryFuzzyQuery"
                  clearable
                />
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.createName }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="createTime" label="创建时间" width="110" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <p class="empty-ps">{{$t('creationTime')}}</p>
                <el-input
                  v-model="searchData6"
                  size="mini"
                  placeholder="Search"
                  @input="dataDictionaryFuzzyQuery"
                  clearable
                />
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.createTime }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="content" label="內容" width="110">
              <template slot="header" slot-scope="scope">
                <p>{{$t('content')}}</p>
                <el-input
                  v-model="searchData7"
                  size="mini"
                  placeholder="Search"
                  @input="dataDictionaryFuzzyQuery"
                  clearable
                />
              </template>
              <template slot-scope="scope">
                <span
                  v-if="scope.row.index === tableCellClickRowIndex && scope.column.index === tableCellClickColumnIndex">
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.content"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
                </span>
                <span v-else>{{ scope.row.content }}</span>
              </template>
            </el-table-column>


            <el-table-column prop="remark" label="备注" width="100">
              <template slot="header" slot-scope="scope">
                <p class="empty-ps">{{$t('remark')}}</p>
                <el-input
                  v-model="searchData8"
                  size="mini"
                  placeholder="Search"
                  @input="dataDictionaryFuzzyQuery"
                  clearable
                />
              </template>
              <template slot-scope="scope">
                <span
                  v-if="scope.row.index === tableCellClickRowIndex && scope.column.index === tableCellClickColumnIndex">
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.remark"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
                </span>
                <span v-else>{{ scope.row.remark }}</span>
              </template>
            </el-table-column>

            <!--            <el-table-column prop="deleteStatus" label="删除状态" width="100">-->
            <!--              <template slot="header" slot-scope="scope">-->
            <!--                <p class="empty-ps">{{$t('deleteState')}}</p>-->
            <!--                <el-input-->
            <!--                  v-model="searchData9"-->
            <!--                  size="mini"-->
            <!--                  placeholder="Search"-->
            <!--                  @input="dataDictionaryFuzzyQuery"-->
            <!--                  clearable-->
            <!--                />-->
            <!--              </template>-->
            <!--              <template slot-scope="scope">-->
            <!--                <span-->
            <!--                  v-if="scope.row.index === tableCellClickRowIndex && scope.column.index === tableCellClickColumnIndex">-->
            <!--                <el-input-->
            <!--                  placeholder="请输入内容…"-->
            <!--                  v-model="scope.row.deleteStatus"-->
            <!--                  size="mini"-->
            <!--                  @blur="tableCellInputBlur"-->
            <!--                  autofocus-->
            <!--                />-->
            <!--                </span>-->
            <!--                <span v-else>{{ scope.row.deleteStatus }}</span>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <!--------------操作----------------->
            <el-table-column label="操作" width="230px" fixed="right">
              <template slot="header">
                <p class="operate">{{$t('operate')}}</p>
                <p class="empty"></p>
              </template>
              <template slot-scope="scope">
                <button class="save-button" @click="handleDeleteDataClick(scope.row)"> 删除</button>
                <button class="save-button" @click="handleSaveClick1(scope.row)"> 保存</button>
                <button class="save-button" @click="handleFindClick(scope.row.code)"> 検索</button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 数据字典分页部分 -->
          <div class="pagination-table">
            <el-pagination
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-size="pageSize1"
              layout=" prev, pager, next"
              :pager-count="5"
              :total="total1"
            >
            </el-pagination>
            <span class="per-page">Rows per page</span>
            <el-dropdown @command="handleCommand1">
              <span class="el-dropdown-link">
                {{ pageSize1 }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">5</el-dropdown-item>
                <el-dropdown-item command="b">10</el-dropdown-item>
                <el-dropdown-item command="c">15</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <!------------------ 右边表格部分 -------------------->
        <div class="right-box">
          <!--          第一行  button 部分-->
          <div class="line-button-box">
            <el-button class="button-css" @click="handleAddClick2">{{$t('dateItemAdd')}} </el-button>
            <el-button class="button-css" @click="handleChangeClickOn">使用</el-button>
            <el-button class="button-css" @click="handleChangeClickOff">停止</el-button>

          </div>
          <el-table
            :data="tableData2"
            style="width: 100%"
            height="560px"
            @selection-change="handleSelectionChange2"
            @cell-click="tableCellClick"
            :cell-class-name="({ row, column, rowIndex, columnIndex }) => (
            (row.index = rowIndex), (column.index = columnIndex))"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <!--       数据项id         -->
            <el-table-column prop="id" label="ID"  min-width="100" :show-overflow-tooltip="true">
              <template slot="header">
                <p>{{$t('id')}}</p>
                <el-input
                  v-model="table1"
                  size="mini"
                  placeholder="Search"
                  @input="handleFindClickS"
                  clearable
                />
                <!-- <el-input
                  v-model="tableSearch1"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
            </el-table-column>
            <!--          数据项唯一标识    -->
            <el-table-column prop="dictCode" label="唯一标识" min-width="120" :show-overflow-tooltip="true">
              <template slot="header" slot-scope="scope">
                <p>{{$t('uniquelyIdentifies')}}</p>
                <el-input
                  v-model="table2"
                  size="mini"
                  placeholder="Search"
                  @input="handleFindClickS"
                  clearable
                />
                <!-- <el-input
                  v-model="tableSearch2"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" min-width="120" :show-overflow-tooltip="true">
              <template slot="header">
                <p>{{$t('dataName')}}</p>
                <el-input
                  v-model="table3"
                  size="mini"
                  placeholder="Search"
                  @input="handleFindClickS"
                  clearable
                />
                <!-- <el-input
                  v-model="tableSearch3"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
              <template slot-scope="scope">
              <span v-if="scope.row.index === tableCellClickRowIndex &&
              scope.column.index === tableCellClickColumnIndex
              ">
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.name"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
                </span>
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="code" label="键值"  :show-overflow-tooltip="true">
              <template slot="header">
                <p>{{$t('keyValue')}}</p>
                <el-input
                  v-model="table4"
                  size="mini"
                  placeholder="Search"
                  @input="handleFindClickS"
                  clearable
                />
                <!-- <el-input
                  v-model="tableSearch4"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
              <template slot-scope="scope">
              <span v-if="scope.row.index === tableCellClickRowIndex &&
              scope.column.index === tableCellClickColumnIndex
              ">
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.code"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
                </span>
                <span v-else>{{ scope.row.code }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot="header">
                <p class="empty-ps">{{$t('status')}}</p>
                <el-input
                  v-model="table5"
                  size="mini"
                  placeholder="Search"
                  @input="handleFindClickS"
                  clearable
                />
                <!-- <el-input
                  v-model="tableSearch5"
                  size="mini"
                  placeholder="Search"
                /> -->
              </template>
              <template slot-scope="scope">
                {{lang == "JP"?scope.row.jpstatus_dictText:scope.row.status_dictText}}
              </template>
            </el-table-column>
            <!--------------操作----------------->
            <el-table-column label="操作" width="90">
              <template slot="header">
                <p class="operate">{{$t('operate')}}</p>
                <p class="empty"></p>
              </template>
              <template slot-scope="scope">
                <button class="save-button" @click="handleSaveClick(scope.row)"> 保存</button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 数据项分页部分 -->
          <div class="pagination-table">
            <el-pagination
              @current-change="handleCurrentChange2"
              :current-page="currentPage2"
              :page-size="pageSize2"
              :pager-count="5"
              layout=" prev, pager, next"
              :total="total2"
            >
            </el-pagination>
            <span class="per-page">Rows per page</span>
            <el-dropdown @command="handleCommand2">
              <span class="el-dropdown-link">
                {{ pageSize2 }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">5</el-dropdown-item>
                <el-dropdown-item command="b">10</el-dropdown-item>
                <el-dropdown-item command="c">15</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>


          <!--      新增数据字典弹出层-->
          <template>
            <div v-if="dialogAdd1Show">

              <!-- 登录的操作部分 -->
              <div class="login-main">
                <div class="register">
                  <div class="box-top">
                    <div class="top-icon" @click="handleCloseDialog">
                      <img src="./assets/Arrow_Right_LG.png" alt=""/>
                    </div>
                  </div>
                  <div class="box-bottom">
                    <div class="bottom-box-title">
                      <p class="welcom">Welcome!</p>
                      <p class="ja-welcome">
                        <span>{{$t('addDataDictionary')}}</span>
                        <el-dropdown class="welcom-dropdown" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ lang }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="0">{{$t('chinese')}}</el-dropdown-item>
                            <el-dropdown-item command="1">{{$t('japanese')}}</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </p>
                    </div>
                    <!-- 表单部分 -->
                    <div class="box-big">
                      <div class="box-form">
                        <!-- 编码	input -->
                        <div class="pop-input">
                          <p class="pop-input-title">{{$t('uniquelyIdentifies')}}</p>
                          <div class="pop-input-css">
                            <input
                              type="text"
                              name=""
                              v-model="code"
                              class="pop-input-css-main"
                            />
                          </div>
                        </div>
                        <!-- 名称	 input -->
                        <div class="pop-input">
                          <p class="pop-input-title">{{$t('dataName')}}</p>
                          <div class="pop-input-css">
                            <input
                              type="text"
                              name=""
                              class="pop-input-css-main"
                              v-model="name"
                            />
                          </div>
                        </div>
                        <!-- 	备注		 input -->
                        <div class="pop-input">
                          <p class="pop-input-title">{{$t('remark')}}</p>
                          <div class="pop-input-css">
                            <input
                              type="text"
                              class="pop-input-css-main"
                              v-model="remark"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- 确定按钮 -->
                      <div class="insure">
                        <button class="insure-button" @click="add1">{{$t('new')}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 新增数据项弹出层 -->
            <div  v-if="dialogPopSHow">
              <div class="register2B">
                <div class="box-top">
                  <div class="top-icon" @click="handleCloseDialog">
                    <img src="./assets/Arrow_Right_LG.png" alt="" />
                  </div>
                </div>
                <div class="box-bottom">
                  <div class="bottom-box-title">
                    <p class="welcom">Welcome!</p>
                    <p class="ja-welcome">
                      <span>{{$t('addDataItem')}}</span>
                      <el-dropdown class="welcom-dropdown" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ lang }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="0">{{$t('chinese')}}</el-dropdown-item>
                          <el-dropdown-item command="1">{{$t('japanese')}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </p>

                  </div>
                  <!-- 表单部分 -->
                  <div class="box-form">

                    <!-- 编码	input -->
                    <div class="pop-input">
                      <p class="pop-input-title">{{$t('keyValue')}}</p>
                      <div class="pop-input-css">
                        <el-input
                          type="text"
                          v-model="code"
                          class="pop-input-css-main"
                          clearable
                        />
                      </div>
                    </div>
                    <!-- 	名称	input -->
                    <div class="pop-input">
                      <p class="pop-input-title">{{$t('dataName')}}</p>
                      <div class="pop-input-css">
                        <el-input
                          type="text"
                          v-model="name"
                          class="pop-input-css-main"
                          clearable
                        />
                      </div>
                    </div>
                  </div>

                  <!-- 确定按钮 -->
                  <div class="insure">
                    <button class="insure-button"  @click="handleDataItemAdd">{{$t('new')}}</button>
                  </div>
                </div>
              </div>
            </div>

          </template>


        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {insertDataDictionary, updateDataDictionary,batchChangeStatus} from "../../js/api";
import {queryDataDictionary, queryFUzzyDataDictionary} from "../../js/api";
import {insertDataItem, updateDataItemCode} from "../../js/api";

import {
  addMedicalInstitutionInfo,
  deleteDataDictionary,
  updateDataItemStatus,
  updateDataItemName,
  queryDataItem
} from "../../js/api";
import AES from "../../js/AES";
export default {
  name: "administratorDataDictionary",
  components: {},
  data() {
    return {
      //数据字典
      table1: '',
      table2: '',
      table3: '',
      table4: '',
      table5: '',
      searchData1 :"", //id
      searchData2 :"", //唯一标识
      searchData3 :"", //名称
      searchData4 :"", // 创建人id
      searchData5 :"",  //创建人名称
      searchData6  :"",//创建时间
      searchData7  :"",//内容
      searchData8  :"",//备注
      searchData9  :"",//删除状态
      currentPage1: 1, //页数
      pageSize1: 5, //每页条数
      //数据项
      tableSearch1: "", //id
      tableSearch2: "", //唯一标识
      tableSearch3: "", //名称
      tableSearch4: "", //键值
      tableSearch5: "", //状态
      currentPage2: 1, //页数
      pageSize2: 5, //每页条数

      total1: 0,
      total2: 0,
      dictCode:"",
      id: "",
      code: "",
      name: "",
      createId: "",
      createName: "",
      createTime: "",
      content: "",
      remark: "",
      deleteStatus: 0,
      dialogAdd1Show: false, //dialog标识
      dialogPopSHow: false, //dialog标识
      tableCellClickRowIndex: null, // 点击的单元格行索引
      tableCellClickColumnIndex: null, // 点击的单元格列索引
      tableData: [], //table数据内容
      tableData2: [],
      multipleSelection1:[],
      multipleSelection2:[],
      lang: "JP", //语言
    };
  },
  created() {
    this.queryDataDictionarydto();
  },
  computed: {
    InputSearch() {
      return this.$t("ifRegisteredEnterName");
    }, //搜索部分的placeholder
  },
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
        this.queryDataDictionarydto();
      }
    },
    //语言转换
    handleCommand(command) {
      if (command === "0") {
        this.$i18n.locale = "zh-CN";
        this.lang = "CN";
      } else {
        this.$i18n.locale = "ja-JP";
        this.lang = "JP";
      }
    },
    //多选
    handleSelectionChange1(val) {
      this.multipleSelection1 =[];
      for(var i=0;i<val.length;i++){
        this.multipleSelection1.push(val[i].id);
      }
      console.log(this.multipleSelection1);
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 =[];
      for(var i=0;i<val.length;i++){
        this.multipleSelection2.push(val[i].id);
      }
      console.log(this.multipleSelection2);
    },
    //分页
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.queryDataDictionarydto();
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.queryDataItem();
    },
    //分页条数
    handleCommand1(command) {
      if (command === "a") {
        this.pageSize1 = 5;
      } else if (command === "b") {
        this.pageSize1 = 10;
      } else {
        this.pageSize1 = 15;
      }
      this.currentPage1=1;
      this.queryDataDictionarydto();
    },
    handleCommand2(command) {
      if (command === "a") {
        this.pageSize2 = 5;
      } else if (command === "b") {
        this.pageSize2 = 10;
      } else {
        this.pageSize2 = 15;
      }
      this.currentPage = 1;
      this.queryDataItem();
    },
    //添加
    handleAddClick1() {
      this.dialogAdd1Show = true;
    },
    handleAddClick2() {
      this.dialogPopSHow = true;
    },
    //dialog 关闭
    handleCloseDialog() {
      this.dialogPopSHow = false;
      this.dialogAdd1Show = false;
    },
    //数据字典修改
    tableCellClick(row, column, cell, event) {
      this.tableCellClickRowIndex = row.index;
      this.tableCellClickColumnIndex = column.index;
    },
    // 单元格失去焦点
    tableCellInputBlur(row, event, column) {
      this.tableCellClickRowIndex = null;
      this.tableCellClickColumnIndex = null;
    },

    //数据字典查询
    queryDataDictionarydto(){
      var fakeInfo ={
        code: "", //唯一标识
        content: "",
        createId: "",
        createName: "",
        createTime:  "",  //创建时间
        deleteStatus: 0,
        id: "", //id
        list: [],
        name: "", //名称
        pageNumber: this.currentPage1,
        pageSize: this.pageSize1,
        remark: "",  //备注
      }
      queryDataDictionary(fakeInfo)
        .then((res) => {
          console.log("-----数据字典查询-----");
          console.log(res);
          if( res.data.code == "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)
            this.total1 = aesFecInfo.total
            this.tableData = aesFecInfo.data

          }else{
            this.$message.error('查询失败。');
          }

        }).catch( (res) =>{} )
    },
 //数据字典数据项查询                                 ----------------------------------------------
    handleFindClickS(){
      // this.dictCode = code;
      var fakeInfo ={
        code: this.table4,
        status:this.table5,
        dictCode: this.table2,
        content: "",
        createId: "",
        createName: "",
        createTime: "",
        deleteStatus: 0,
        id: this.table1,
        list: [],
        name: this.table3,
        pageNumber: this.currentPage2,
        pageSize: this.pageSize2,
        remark: ""
      }
      console.log('看看分页内容---->', fakeInfo, this.currentPage, this.pageSize)
      queryDataItem(fakeInfo)
        .then((res) => {
          console.log("-----数据字典数据项查询-----");
          console.log(res);
          if( res.data.code == "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)
            this.total2 = aesFecInfo.total
            this.tableData2 = aesFecInfo.data

          }else{
            this.$message.error('查询失败。');
          }

        }).catch( (res) =>{} )
    },

    //数据字典数据项查询                                 ----------------------------------------------
    handleFindClick(code){
      console.log(code)
      this.dictCode = code;
      var fakeInfo ={
        dictCode: code,
        content: "",
        createId: "",
        createName: "",
        createTime: "",
        deleteStatus: 0,
        id: "",
        list: [],
        name: "",
        pageNumber: this.currentPage2,
        pageSize: this.pageSize2,
        remark: ""
      }
      console.log('看看分页内容---->', fakeInfo, this.currentPage, this.pageSize)
      queryDataItem(fakeInfo)
        .then((res) => {
          console.log("-----数据字典数据项查询-----");
          console.log(res);
          if( res.data.code == "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)
            this.total2 = aesFecInfo.total
            this.tableData2 = aesFecInfo.data

          }else{
            this.$message.error('查询失败。');
          }

        }).catch( (res) =>{} )
    },

    add1() {
      //新增数据字典接口
      var fakeInfo = {
        code: this.code,
        name: this.name,
        remark: this.remark,
      };
      insertDataDictionary(fakeInfo)
        .then((res) => {
          console.log("新增数据字典接口数据:", res)
          if(res.data.code === "A0000"){
            this.dialogAdd1Show = false;
            this.$message({
              message: this.$t('addedSuccessfully'),
              type: 'success'
            });
            location. reload()
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log("新增数据字典接口数据异常:", res)
        })
    },

    //新增数据项接口
    handleDataItemAdd(){
      var dto={
        code: this.code,
        dictCode: this.dictCode,
        id: "",
        name: this.name,
        status: 0,
      }
      insertDataItem(dto).then((res)=>{
        console.log("--------新增数据字典数据项接口数据--------");
        console.log(res);
        if(res.data.code === "A0000"){
          this.dialogPopSHow = false;
          this.$message({
            message: this.$t('addedSuccessfully'),
            type: 'success'
          });
          this.handleFindClick(this.dictCode);
        }
        else{
          this.$message.error('数据项添加失败。');
        }
      }).catch((res)=>{
        console.log("新增数据字典数据项接口数据异常:",res)
      })
      this.dialogPopSHow = false;
    },

    //数据字典模糊查询
    dataDictionaryFuzzyQuery(){
      var dto = {
        code: this.searchData2, //唯一标识
        content: this.searchData7,
        createId: this.searchData4,
        createName: this.searchData5,
        createTime:  this.searchData6,  //创建时间
        deleteStatus: this.searchData9,
        id: this.searchData1, //id
        list: [],
        name: this.searchData3, //名称
        pageNumber: this.currentPage1,
        pageSize: this.pageSize1,
        remark: this.searchData8,  //备注
      }
      queryFUzzyDataDictionary(dto)
        .then((res) => {
          console.log("-----数据字典模糊查询-----");
          console.log(res);
          if( res.data.code === "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)
            this.total1 = aesFecInfo.total
            this.tableData = aesFecInfo.data
          }else{
            this.$message.error(this.$t('queryFailed'));
          }

        }).catch( (res) =>{} )
    },
    //数据字典删除
    handleDeleteDataClick(row) {
      var fakeInfo =
        {
          list: [row.id],
        }
      deleteDataDictionary(fakeInfo)
        .then((res) => {
          console.log("数据字典删除接口数据:", res)
          if (res.data.code === "A0000") {
            this.dialogAdd1Show = false;
            this.$message({
              message:this.$t('successfullyDeleted'),
              type: 'success'
            });
            location. reload()
          } else {
            this.$message.error(this.$t('failedToDelete'));
          }
        })
        .catch((res) => {
          console.log("数据字典删除接口数据异常:", res)
        })
    },
    //修改数据字典
    handleSaveClick1(row) {
      var fakeInfo = {
        code: row.code,
        content: row.content,
        createId: row.createId,
        createName: row.createName,
        createTime: row.createTime,
        deleteStatus: row.deleteStatus,
        id: row.id,
        list: [],
        name: row.name,
        pageNumber: this.currentPage1,
        pageSize: this.pageSize1,
        remark: row.remark,
      }
      updateDataDictionary(fakeInfo).then((res) => {
        console.log("修改数据字典接口数据", res)
        if (res.data.code === "A0000") {
          this.$message({
            message: this.$t('successfullyModified'),
            type: 'success'
          });
        } else {
          this.$message.error(this.$t('failToEdit'));
        }
      }).catch((res) => {
        console.log("修改数据字典接口数据异常", res)
      })
    },
    //修改数据项
    handleSaveClick(row) {
      console.log("＋保存button");
      console.log(row.name);
      if (row.name === null) {
        this.$message({
          message: this.$t('changeNameEmpty'),
          type: "warning",
        });
      }
      var fakeInfo = {
        code: row.code,
        dictCode: this.dictCode,
        id: row.id,
        name: row.name,
        status: row.status
      };
      //修改数据项名称
      updateDataItemName(fakeInfo)
        .then((res) => {
          console.log("--------修改数据项名称--------");
          console.log(res);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t('nameChangedSuccessfully'),
              type: 'success'
            });
          } else {
            this.$message.error(this.$t('nameChangeFailed'));
          }
        })
        .catch((res) => {
        });
      //修改数据项编码
      updateDataItemCode(fakeInfo)
        .then((res) => {
          console.log("--------修改数据项编码--------");
          console.log(res);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t('KeyModifiedSuccessfully'),
              type: 'success'
            });
          } else {
            this.$message.error(this.$t('failedModifyKeyValue'));
          }
        })
        .catch((res) => {
        });
    },

    //启用数据项
    handleChangeClickOn() {
      var fakeInfo = {
        listId: this.multipleSelection2,
        status: 0,
      }
      batchChangeStatus(fakeInfo)
        .then((res) => {
          console.log("修改数据项状态接口数据:", res)
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t('activated'),
              type: 'success'
            });
          } else {
            this.$message.error(this.$t('failedModifyStatus'));
          }
          this.handleFindClick(this.dictCode);
        })
        .catch((res) => {
          console.log("修改数据项状态接口数据异常:", res)
        })
    },
    //停用数据项
    handleChangeClickOff() {
      var fakeInfo = {
        listId: this.multipleSelection2,
        status: 1,
      }
      batchChangeStatus(fakeInfo)
        .then((res) => {
          console.log("修改数据项状态接口数据:", res)
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t('hasStopped'),
              type: 'success'
            });
          } else {
            this.$message.error(this.$t('failedModifyStatus'));
          }
          this.handleFindClick(this.dictCode);
        })
        .catch((res) => {
          console.log("修改数据项状态接口数据异常:", res)
        })
    },
  },
};
</script>
<style scoped>
.main-box {
  width: 100%;
  height: 100%;
  background: #fff;
}

.main-box-all-css {
  width: 100%;
  margin: 0 auto;
}

.main-box-css {
  display: flex;
  height: 620px;
  padding: 30px 0 0 0;
}

.left-box {
  width: 45%;
  height: 100%;
  margin-left: 50px;
  padding-top: 10px;
  box-sizing: border-box;
}

.left-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
}

.left-box .empty {
  height: 30px;
}

.avatar img {
  width: 150px;
  height: 150px;
}

.institution-name {
  height: 150px;
  flex: 1;
}

.institution-box {
  width: 300px;
  height: 57px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-left: 35px;
  position: relative;
  margin-top: 70px;
  float: right;
}
.welcom {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #98989e;
  margin: 3px 0px;
}
.institution-title {
  background: #fc630c;
  border-radius: 4px;
  height: 16px;
  width: 49px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: -0.02em;
  color: #ffffff;
  text-align: center;
  position: absolute;
  top: -22px;
  right: 0;
}

.institution-box span {
  position: absolute;
  display: inline-block;
  padding: 0 5px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  background: #ffffff;
}

.institution-main {
  margin-top: 15px;
  padding: 0 20px;
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
}

.small-input-box {
  width: 200px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}

.small-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.small-box-title {
  margin-top: 12px;
  padding-left: 20px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
}

.big-input-box {
  width: 290px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}

.big-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.big-input-box /deep/ .el-input {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}

.big-input-box /deep/ .el-input__inner {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}

.inline-box-dropdown {
  height: 38px;
  width: 180px;
  margin-top: 2px;
  margin-left: 10px;
}

.inline-box-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 180px;
}

.inline-box-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 170px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}

.inline-box-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}

.small-dropdown {
  width: 140px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}

.small-dropdown span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.small-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 110px;
}

.small-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 110px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}

.small-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}

.inline-box-dropdown1 {
  height: 38px;
  width: 110px;
  margin-top: 2px;
  margin-left: 10px;
}

.textarea-line {
  margin-top: 15px;
  width: 500px;
  height: 180px;
}

.textarea-line-box {
  width: 500px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}

.textarea-line-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.right-box {
  width: 45%;
  height: 100%;
  margin-left: 50px;
  padding-top: 10px;
  box-sizing: border-box;
}

.right-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
}

.right-box .empty {
  height: 30px;
}

.right-box /deep/ .caret-wrapper {
  position: absolute;
  top: -4px;
  right: 20px;
}

.empty-ps {
  position: relative;
}

.pagination-table {
  display: flex;
  height: 40px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 0.25px;
  color: #454d59;
  margin-top: 10px;
  align-items: center;
  justify-content: right;
}

.pagination-table /deep/ .el-dropdown {
  background: #ffffff;
  width: 60px;
  line-height: 24px;
  height: 24px;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  margin-left: 10px;
}

.pagination-table /deep/ .el-dropdown-link {
  width: 60px;
  height: 24px;
  padding-left: 10px;
  box-sizing: border-box;
  display: inline-block;
}

.pagination-table /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 24px;
  margin-right: 5px;
}

.per-page {
  margin-left: 20px;
}

.main-button-box {
  text-align: center;
  width: 500px;
  margin-top: 20px;
}

.main-button-box button {
  width: 152px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}

.textarea-css-main {
  width: 99%;
  height: 99%;
  margin-left: 1px;
  margin-top: 1px;
  border-radius: 8px;
  padding: 15px 5px 5px 20px;
  box-sizing: border-box;
}

.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}

.save-button {
  width: 60px;
  height: 25px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 5px;
}

.title-css { /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #686868; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 76px; /*行间距*/
  margin-top: 10px;
}

.main-box /deep/ .el-table::before {
  height: 0px;
}


/*弹窗css*/
.pop-true-css {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  box-sizing: border-box;
  display: inline-block;
  margin-left: 10px;
  color: #f56c6c;
}
.dialog-main img {
  width: 66px;
  height: 66px;
  margin-bottom: 30px;
  margin-top: 37px;
}

.dialog-main p {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
}

.login-main {
  flex: 1;
  background: #ffffff;
  position: relative;
}

.register {
  background: #ffffff;
  border: 2px solid #ececec;
  box-sizing: border-box;
  border-radius: 8px;
  width: 404px;
  height: 630px;
  position: absolute;
  left: 10%;
  margin-left: -750px;
  margin-top: -700px;
  z-index: 10;
}

.register2B {
  background: #ffffff;
  border: 2px solid #ececec;
  box-sizing: border-box;
  border-radius: 8px;
  width: 404px;
  height: 630px;
  position: absolute;
  left: 50%;
  margin-left: 270px;
  margin-top: -700px;
  z-index: 10;
}

.box-top {
  height: 50px;
  line-height: 50px;
  width: 100%;
}

.top-icon {
  width: 50px;
  height: 50px;
  float: right;
  text-align: center;
  cursor: pointer;
}

.box-bottom {
  height: 630px;
  padding: 0 40px;
}

.bottom-box-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 324px;
  height: 56px;
}

.ja-welcome {
  width: 100%;
  height: 32px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #212429;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.box-big {
  width: 310px;
  overflow: hidden;
}

.box-form {
  margin-top: 30px;
  height: 400px;
  width: 330px;
}

.pop-input {
  padding: 0px;
  width: 300px;
  height: 66px;
  margin-bottom: 10px;
}

.pop-input-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #686868;
  margin: 8px 0px;
}

.pop-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 300px;
  box-sizing: border-box;
}

.pop-icon {
  margin-right: 10px;
  margin-left: 15px;
}

.pop-input-css-main {
  width: 250px;
  height: 38px;
  line-height: 38px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
  margin-left: 20px;
}
.pop-input-css-main /deep/ .el-input__inner{
  height: 38px;
}

.two-button button {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  width: 150px;
  height: 40px;
  background: #fff;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-right: 8px;
}

.insure {
  height: 50px;
  margin-top: 13px;
  margin-bottom: 10px;
}

.insure-button {
  background: #fc630c;
  border-radius: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #ffffff;
  width: 300px;
  height: 50px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorDataDictionary/index.vue